;(function () {
  'use strict'

  angular.module('contrast.utils').factory('TranslationUtils', TranslationUtils)

  function TranslationUtils($translate) {
    'ngInject'

    return {
      toSentence: toSentence
    }

    function toSentence(list) {
      var wordsConnector = $translate.instant('detail_andConjunction')
      return listToSentence(
        list,
        ', ',
        ' ' + wordsConnector + ' ',
        ', ' + wordsConnector + ' '
      )
    }

    function listToSentence(
      list,
      wordsConnector,
      twoWordsConnector,
      lastWordConnector
    ) {
      if (Array.isArray(list)) {
        switch (list.length) {
          case 0:
            return ''

          case 1:
            return list[0]

          case 2:
            return list[0] + twoWordsConnector + list[1]

          default:
            return (
              list.slice(0, list.length - 1).join(wordsConnector) +
              lastWordConnector +
              list[list.length - 1]
            )
        }
      }
      return ''
    }
  }
})()
